import Chevron from "assets/icons/chevron.svg"
import { ImageFragment } from "client/graphql/commerce-v2-api"
import {
  ChevronButton,
  ImageContainer,
  ImageNumber,
  NavigationButtonContainer,
  SelectedImageContainer,
  SelectedImageInnerContainer,
  SelectedImageWrapper,
  SelectImageButton,
} from "client/packages/commerce/components/product/ImageGallery"
import { CommerceFooter } from "client/packages/commerce/components/ui/styles/CommerceFooters"
import { ScrollWrapper } from "client/packages/commerce/components/ui/styles/Containers"
import { FormattedMessage } from "react-intl"
import BackButton from "shared/components/buttons/BackButton"
import useArrayElement from "shared/utils/useArrayElement"

export type ImageGalleryProps = {
  images: ImageFragment[]
  onBack: () => void
  initialIndex?: number
}

const ImageGallery = ({
  images,
  onBack,
  initialIndex,
}: ImageGalleryProps) => {
  const [selectedImage, { next, prev, index, setIndex }] = useArrayElement(
    images,
    initialIndex,
  )

  return (
    <>
      <ScrollWrapper>
        {selectedImage ? (
          <SelectedImageContainer>
            <NavigationButtonContainer>
              <ChevronButton onClick={prev}>
                <Chevron />
              </ChevronButton>
              <ImageNumber>
                <FormattedMessage
                  id="image.number"
                  defaultMessage="Image {ofnumber} of {oftotal}"
                  values={{
                    ofnumber: index + 1,
                    oftotal: images.length,
                  }}
                />
              </ImageNumber>
              <ChevronButton onClick={next}>
                <Chevron />
              </ChevronButton>
            </NavigationButtonContainer>
            <SelectedImageInnerContainer>
              <SelectedImageWrapper>
                <img
                  alt={selectedImage.altText ?? ""}
                  src={selectedImage.url}
                />
              </SelectedImageWrapper>
            </SelectedImageInnerContainer>
          </SelectedImageContainer>
        ) : (
          <ImageContainer>
            {images.map((image, thisIndex) => (
              <SelectImageButton
                key={image.altText}
                onClick={() => {
                  setIndex(thisIndex)
                }}
                type="button"
              >
                <img alt={image.altText ?? ""} src={image.url} />
              </SelectImageButton>
            ))}
          </ImageContainer>
        )}
      </ScrollWrapper>
      <CommerceFooter>
        <BackButton onClick={onBack} />
      </CommerceFooter>
    </>
  )
}

export default ImageGallery
